var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpattendanceclock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.1C11.5156 17.1 13.4487 16.2993 14.874 14.874C16.2993 13.4487 17.1 11.5156 17.1 9.5C17.1 7.48435 16.2993 5.55126 14.874 4.12599C13.4487 2.70071 11.5156 1.9 9.5 1.9C7.48435 1.9 5.55126 2.70071 4.12599 4.12599C2.70071 5.55126 1.9 7.48435 1.9 9.5C1.9 11.5156 2.70071 13.4487 4.12599 14.874C5.55126 16.2993 7.48435 17.1 9.5 17.1ZM9.5 0C10.7476 0 11.9829 0.245725 13.1355 0.723144C14.2881 1.20056 15.3354 1.90033 16.2175 2.78249C17.0997 3.66464 17.7994 4.71191 18.2769 5.86451C18.7543 7.0171 19 8.25244 19 9.5C19 12.0196 17.9991 14.4359 16.2175 16.2175C14.4359 17.9991 12.0196 19 9.5 19C4.2465 19 0 14.725 0 9.5C0 6.98044 1.00089 4.56408 2.78249 2.78249C4.56408 1.00089 6.98044 0 9.5 0ZM9.975 4.75V9.7375L14.25 12.274L13.5375 13.4425L8.55 10.45V4.75H9.975Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpattendanceclock);
export default __webpack_public_path__ + "static/media/tpattendanceclock.c21b28ccf449a9ba285e1df4f17887be.svg";
export { ForwardRef as ReactComponent };